import { atomFamily, selector } from 'recoil';
import subDays from 'date-fns/subDays';
import { TDateRange } from '@types';

/* eslint-disable */
const keys = {
	ANALYTICS_DATE_RANGE:				'@Ofload/AnalyticsDateRange',
	ANALYTICS_DATE_RANGE_DEFAULT:		'@Ofload/AnalyticsDateRangeDefault',
	ANALYTICS_SELECTED_SHIPPERS:		'@Ofload/AnalyticsSelectedShippers',
	ANALYTICS_SELECTED_LOCATION_GROUPS:	'@Ofload/AnalyticsSelectedLocationGroups',
	ANALYTICS_SELECTED_PICKUP_LOCATIONS:	'@Ofload/AnalyticsSelectedPickupLocations',
	ANALYTICS_SELECTED_DROPOFF_LOCATIONS:	'@Ofload/AnalyticsSelectedDropoffLocations',
}
/* eslint-enable */

/* The 89-day offset mirrors the "Last 90 days" preset in AnalyticsFilterBar,
   so that preset reads as active when the dashboard loads. */
const DEFAULT_DAYS_BACK = 89;

const resolveDefaultAnalyticsRange = (): TDateRange => {
	const today = new Date();
	return {
		start: subDays(today, DEFAULT_DAYS_BACK),
		end: today,
	};
}

const defaultAnalyticsRange = selector<TDateRange>({
	key: keys.ANALYTICS_DATE_RANGE_DEFAULT,
	get: () => resolveDefaultAnalyticsRange(),
});

/* Shared by every Analytics tab — DIFOT, SIFOT, Price and Carbon — via AnalyticsFilterBar. */
export const AnalyticsDateRange = atomFamily<TDateRange, number | null>({
	key: keys.ANALYTICS_DATE_RANGE,
	default: defaultAnalyticsRange,
});

// Default the shipper filter to the cost centre currently in context.
export const AnalyticsSelectedShippers = atomFamily<number[], number | null>({
	key: keys.ANALYTICS_SELECTED_SHIPPERS,
	default: (sid) => (sid ? [sid] : []),
});

export const AnalyticsSelectedLocationGroups = atomFamily<number[], number | null>({
	key: keys.ANALYTICS_SELECTED_LOCATION_GROUPS,
	default: [],
});

export const AnalyticsSelectedPickupLocations = atomFamily<string[], number | null>({
	key: keys.ANALYTICS_SELECTED_PICKUP_LOCATIONS,
	default: [],
});

export const AnalyticsSelectedDropoffLocations = atomFamily<string[], number | null>({
	key: keys.ANALYTICS_SELECTED_DROPOFF_LOCATIONS,
	default: [],
});
